import { useTranslation } from "react-i18next"
import { useFragment } from "react-relay"
import { GeneralHealthInformationFragment$key } from "@/modules/patients/services/__generated__/GeneralHealthInformationFragment.graphql"
import { GeneralHealthInformationFragment } from "@/modules/patients/services/GeneralHealthInformationFragment"

interface GeneralHealthInformationSummaryProps {
  generalHealthInformationKey: GeneralHealthInformationFragment$key
}

const GeneralHealthInformationSummary = ({ generalHealthInformationKey }: GeneralHealthInformationSummaryProps) => {
  const { t } = useTranslation()
  const generalHealthInformation = useFragment<GeneralHealthInformationFragment$key>(
    GeneralHealthInformationFragment,
    generalHealthInformationKey,
  )

  const entries: { label: string; value: string }[] = []

  if (generalHealthInformation.conditions !== null && generalHealthInformation.conditions !== undefined) {
    entries.push({
      label: t("episodeOfCare.progressNote.generalHealthInformation.conditions"),
      value: generalHealthInformation.conditions,
    })
  }

  if (generalHealthInformation.allergies !== null && generalHealthInformation.allergies !== undefined) {
    entries.push({
      label: t("episodeOfCare.progressNote.generalHealthInformation.allergies"),
      value: generalHealthInformation.allergies,
    })
  }

  if (generalHealthInformation.medication !== null && generalHealthInformation.medication !== undefined) {
    entries.push({
      label: t("episodeOfCare.progressNote.generalHealthInformation.medication"),
      value: generalHealthInformation.medication,
    })
  }

  if (entries.length === 0) {
    return null
  }

  return (
    <div className="bg-surface-subdued rounded-md p-3" data-testid="general-health-information-summary">
      <span className="text-on-surface-subdued mb-2 block text-xs font-medium">
        {t("episodeOfCare.progressNote.generalHealthInformation.title")}
      </span>
      <div className="flex flex-col gap-1.5">
        {entries.map((entry) => (
          <div key={entry.label}>
            <span className="text-on-surface-subdued block text-xs">{entry.label}</span>
            <span className="text-on-surface text-sm wrap-break-word">{entry.value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export { GeneralHealthInformationSummary }
